import {
    DownloadIcon,
    UploadIcon,
    XIcon
} from '@primer/octicons-react';
import { Box } from "@primer/react";
import { FileUploader } from 'devextreme-react';
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Checkbox } from "semantic-ui-react";
import { ganMienGiamApi } from "../../../api/ganMienGiamApi";
import { appInfo } from '../../../AppInfo';
import DataGrid from "../../../components/data-grid";
import { IDataGridColumn } from "../../../components/data-grid/type/IDataGridProps";
import Button from "../../../components/ui/button";
import Modal from '../../../components/ui/modal';
import ModalActions from '../../../components/ui/modal/ModalActions';
import { useCommonContext } from "../../../contexts/common";
import { showNotify } from "../../../helpers/toast";
import { PageBaseStatus } from "../../../models/pageBaseStatus";
import { RootState } from "../../../state/reducers";
type GanMienGiamImportModalProps = {
    onClose: () => void,
    onSuccess: () => void,
    nam_hoc: string,
    animationOf: string
}
type GanMienGiamImportModalState = {
    status: PageBaseStatus,
    file_name: string,
    sheets: any[],
    sheet_index: number,
    data_source: any[],
    root_file_name: string

}
const initialState: GanMienGiamImportModalState = {
    status: PageBaseStatus.is_completed,
    data_source: [],
    file_name: "",
    sheet_index: -1,
    sheets: [],
    root_file_name: ''

}
export const GanMienGiamImportModal = (props: GanMienGiamImportModalProps) => {
    const [formData, SetFormData] = useState<GanMienGiamImportModalState>(initialState);
    const [isLoading, SetIsLoading] = useState<boolean>(false)
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [isLoadingSheets, SetIsLoadingSheets] = useState<boolean>(false)
    const { dm_coso_id } = useSelector((x: RootState) => x.common);

    const { createUUID } = useCommonContext();
    const onClose = useCallback(() => {
        window.animationHidePopup(props.animationOf || "")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [props.animationOf])
    const grid = useRef<any>();
    const {
        status,
        file_name,
        sheets,
        sheet_index,
        data_source,
        root_file_name
    } = formData;
    //useEffect(() => {
    //    if (file_name) {
    //        reloadSheets();
    //    }
    //}, [file_name]);
    useEffect(() => {
        if (file_name !== "" && sheets.length > 0 && sheet_index >= 0) {
            reloadDatas();
        }
    }, [file_name, sheet_index, sheets]);


    const errr_code = useMemo(() => {
        const count = data_source.filter(x => !x.is_valid).length;
        if (count > 0) {
            return `Có ${count} dòng không hợp lệ, vui lòng kiểm tra lại dữ liệu`;
        }
        return "";
    }, [data_source]);

    const reloadSheets = async () => {
        SetIsLoadingSheets(true);
        const res = await ganMienGiamApi.getSheets(file_name);
        SetIsLoadingSheets(false)
        if (res.is_success) {
            SetFormData({ ...formData, sheets: res.data })
            if (res.data.length >= 1) {
                SetFormData({ ...formData, sheet_index: 0 })
            }
        }
    }
    const reloadDatas = async () => {
        SetIsLoading(true);
        const res = await ganMienGiamApi.readFiles({
            file_name: file_name, sheet_index: sheet_index,
            nam_hoc: props.nam_hoc, dm_coso_id: dm_coso_id, root_file_name: root_file_name
        });
        SetIsLoading(false)
        if (res.is_success) {
            SetFormData({ ...formData, data_source: res.data })
        } else {
            showNotify({ message: res.message || "Có lỗi, vui lòng kiểm tra lại sheet", type: "error" })
            SetFormData({ ...formData, data_source: [] })
        }

    }
    const handleSaveChanges = async () => {
        setIsSaving(true)
        const res = await ganMienGiamApi.import({
            file_name: file_name, sheet_index: sheet_index,
            nam_hoc: props.nam_hoc, dm_coso_id: dm_coso_id, root_file_name: root_file_name
        });
        setIsSaving(false)
        if (res.is_success) {
            showNotify({ message: "Import thành công", type: 'success' })
            props.onSuccess();
        } else {
            showNotify({ message: res.message || "Có lỗi", type: "error" })
        }
    };
    const onUploaded = (e: any) => {
        if (e && e.request && e.request.response) {
            const res = JSON.parse(e.request.response)
            if (res.is_success) {
                SetFormData({ ...formData, file_name: res.data.url, sheets: res.data.sheets, sheet_index: res.data.sheets.length > 0 ? 0 : -1 })
                //SetFormData({ ...formData, file_name: res.data[0].file_name_uploaded })
            }
        }
    }
    const columns = useMemo<IDataGridColumn[]>(() => {
        return [
            {
                caption: "TT",
                id: "id",
                dataField: "id",
                width: 80,
            },
            {
                caption: "Năm học",
                id: "Nam_hoc",
                dataField: "Nam_hoc",
                width: 100,
            },
            {
                caption: "Mã học sinh",
                id: "Ma_hoc_sinh",
                dataField: "Ma_hoc_sinh",
                width: 120,
            },
            {
                caption: "Mã miễn giảm",
                id: "Ma_mien_giam",
                dataField: "Ma_mien_giam",
                width: 200,
            },
            {
                caption: "Ghi chú",
                id: "Ghi_chu",
                dataField: "Ghi_chu",
                width: 200,
            },
            {
                caption: "Hợp lệ",
                id: "is_valid",
                dataField: "is_valid",
                width: 100,
                cellRender: (data: any) => (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Checkbox checked={data.is_valid === true} aria-label="Hợp lệ" />
                    </div>
                ),
            },
            {
                caption: "Mã lỗi",
                id: "error",
                dataField: "error",
                width: 450,
            }
        ];
    }, []);

    return (
        <Modal isOpen
            title={`Import khoản miễn giảm năm học ${props.nam_hoc}`}
            onClose={() => {
                props.onClose()
            }}
            width={'70%'}
        >
            <div className="pop-up-form">
                <div className="row">
                    <div className="col-md-12">
                        {errr_code && <p className="text-danger padding-top-1rem">{errr_code}</p>}
                    </div>
                    <Box className="col-md-12">
                        <DataGrid
                            title={
                                <FileUploader
                                    multiple={false}
                                    accept={".xls,.xlsx"}
                                    uploadMode={"instantly"}
                                    uploadHeaders={{ Authorization: `Bearer ${localStorage.access_token}` }}
                                    uploadUrl={`${appInfo.baseApiURL}/sf_dexuatmiengiam/upload_file`}
                                    uploadMethod='POST'
                                    showFileList={false}
                                    onUploaded={onUploaded}
                                    labelText='hoặc kéo thả file tại đây để upload'
                                    selectButtonText='Chọn file'
                                />
                            }
                            dataSource={data_source}
                            isLoading={isLoading}
                            height={window.innerHeight - 220}
                            searchEnable={true}
                            filterRow={{
                                enable: true
                            }}
                            actionComponent={
                                <Box sx={{ display: "flex" }}>
                                    <Button sx={{ ml: 2 }} variant="primary" size="medium">
                                        <a href="../../template/import_mien_giam.xlsx" target="_blank" style={{ textDecoration: "none", color: "white" }}>
                                            <DownloadIcon />
                                            Tải file mẫu
                                        </a>
                                    </Button>
                                </Box>
                            }
                            columns={columns}
                            paging={{
                                enable: true,
                                pageSize: 50,
                                pageSizeItems: [50, 100, 200, 500]
                            }}
                        />
                    </Box>

                </div>
            </div>
            <ModalActions>
                <Button sx={{ ml: 2 }} variant="default" size='medium' leadingVisual={XIcon} onClick={onClose}>Đóng</Button>
                <Button sx={{ ml: 2 }} variant="primary" size='medium' leadingVisual={UploadIcon} onClick={handleSaveChanges} isLoading={isSaving} disabled={errr_code !== ""}>Import</Button>
            </ModalActions>
        </Modal>
    )
}